var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1535,
    height: 2500,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M127.962 0L0 212.32l127.962 75.639V154.158z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M127.962 416.905v-104.72L0 236.585z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M127.961 287.958l127.96-75.637-127.96-58.162z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M0 212.32l127.96 75.638v-133.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.1dd9c6f509b26711eac9acd2d5eebba8.svg";
export { ForwardRef as ReactComponent };